// extracted by mini-css-extract-plugin
module.exports = {"quantityContainer":"ProductDetails_quantityContainer__1U8QV"};